import Vue from '@triotech/vue-core/src/vendor/vue';

const Axios = new Vue({
  created() {
    if (this.$env.dev) {
      this.$http.defaults.timeout = 30000;
    }
  },
});

Vue.set(Vue.prototype, '$', Axios);

export default Axios;
